import memoize from 'lodash/memoize';

import { emailSchema } from '../sign-up-user-email/sign-up-user-email.validation';
import { userProfileSchema } from '../sign-up-user-profile/sign-up-user-profile.validation';
import { companyProfileSchema } from '../sign-up-company-profile/sign-up-company-profile.validation';
import { convertYupErrorToMessagesObject } from '../../../shared/utils/validation.utils';
import { signUpSinglePageSchema } from '../sign-up-single-page/sign-up-single-page.validation';

const STEP_SCHEMAS = {
    1: emailSchema,
    2: userProfileSchema,
    3: companyProfileSchema,
    'sign-up-single-page': signUpSinglePageSchema,
};

const getSchema = memoize(step => STEP_SCHEMAS[step]());

export const validateStep = async ({
    step,
    data,
}) => {
    const schema = await getSchema(step);
    return schema.validate(data, { abortEarly: false }).catch(
        error => Promise.reject(convertYupErrorToMessagesObject(error)),
    );
};
